export const BRANDS = [
  {
    title: 'Shop Vigoro',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-vigoro.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Vigoro/N-5yc1vZbx6kZ1kt'
  },
  {
    title: 'Shop Pavestone',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-pavestone.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Pavestone/N-5yc1vZbx6kZ411'
  },
  {
    title: 'Shop Scotts',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-scotts.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Scotts/N-5yc1vZbx6kZ3qj'
  },
  {
    title: 'Shop Miracle-Gro',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-miracle-gro.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Miracle-Gro/N-5yc1vZbx6kZ4b3'
  },
  {
    title: 'Shop Pennington',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-penningston.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Pennington/N-5yc1vZbx6kZ2jy'
  },
  {
    title: 'Shop Ryobi',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-ryobi.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/RYOBI/N-5yc1vZbx6kZm5d'
  },
  {
    title: 'Shop Oldcastle',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-oldcastle.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Oldcastle/N-5yc1vZbx6kZ133'
  },
  {
    title: 'Shop Ortho',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-ortho.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Ortho/N-5yc1vZbx6kZ2yq'
  },
  {
    title: 'Shop MSI',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-msi.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/MSI/N-5yc1vZbx6kZm5h'
  },
  {
    title: 'Shop PROVEN WINNERS',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-proven-winners.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/PROVEN-WINNERS/N-5yc1vZbx6kZr16'
  },
  {
    title: 'Shop Greenes Fences',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-greenes.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Greenes-Fence/N-5yc1vZbx6kZ6d8'
  },
  {
    title: 'Shop Kellogg',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-kellogg.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Kellogg-Garden-Organics/N-5yc1vZbx6kZefj'
  },
  {
    title: 'Shop Online Orchards',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-online-orchards.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Online-Orchards/N-5yc1vZbx6kZnxj'
  },
  {
    title: 'Shop Roundup',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-roundup.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Roundup/N-5yc1vZbx6kZ4b5'
  },
  {
    title: 'Shop Alpine',
    src: 'https://assets.thdstatic.com/images/v1/brand-logos/brands-alpine.png',
    href: 'https://www.homedepot.com/b/Outdoors-Garden-Center/Alpine-Corporation/N-5yc1vZbx6kZexj'
  },
];